import {
	type ScenarioAcceptRequest,
	type ScenarioProposeRequest,
	scenarioAccept,
	scenarioCurrent,
	scenarioPending,
	scenarioPropose,
} from "@/shared/api/generated-social"
import type {
	PendingScenario,
	Scenario,
	ScenarioPairState,
} from "../model/types"

export async function getPendingScenarios(): Promise<PendingScenario[]> {
	return scenarioPending()
}

export async function getScenario(friendId: number): Promise<Scenario> {
	return scenarioCurrent({
		path: { friend_id: friendId },
	})
}

export async function proposeScenario(
	friendId: number,
	body: ScenarioProposeRequest,
): Promise<ScenarioPairState> {
	const { scenarios } = await scenarioPropose({
		path: { friend_id: friendId },
		body,
	})
	return scenarios
}

export async function acceptScenario(
	friendId: number,
	body: ScenarioAcceptRequest,
): Promise<ScenarioPairState> {
	const { scenarios } = await scenarioAccept({
		path: { friend_id: friendId },
		body,
	})
	return scenarios
}
